import React, { useEffect, useState } from "react";
import {
  AppBar,
  Box,
  Button,
  Dialog,
  DialogContent,
  Icon,
  IconButton,
  Toolbar,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { toast } from "react-toastify";
import OAuthService from "src/app/auth/services/oAuthService";
import PDFViewer from "app/shared-components/PDFViewer";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon/FuseSvgIcon";
import { border } from "@mui/system";
import { useLocation } from "react-router-dom";
import { useTheme } from "@mui/material/styles";

export default function ViewPDF(props) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const { open, handleClose, abFiles, title } = props;
  const [pdfUrl, setPdfUrl] = useState(null);
  const [pdfError, setPdfError] = useState("");
  const [isMinimized, setIsMinimized] = useState(false);
  const location = useLocation();
  const showMinimize = /^\/order\/order-details\/[^/]+$/.test(location.pathname);
  const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}`;
  const abNumber = title?.split("-")[1];

  const loadABFile = async () => {
    try {
      if (props?.abFiles) {
        const fileId = Array.isArray(props?.abFiles)
          ? props.abFiles[0]?.id
          : props.abFiles?.id;

        const file = await OAuthService.getPostPdf(
          props?.flag
            ? url + `api/downloadCustomerAbFile/${fileId}`
            : url + `api/downloadAbFile/${fileId}`
        );
        const blob = new Blob([file?.data], { type: "application/pdf" });
        const blobUrl = URL.createObjectURL(blob);
        setPdfUrl(blobUrl);
        setPdfError("");
      }
    } catch (error) {
      toast.error(error?.response?.data?.errorMessage || "Error loading PDF");
      setPdfError(
        "Error loading PDF"
      );
    }
  };

  useEffect(() => {
    if (open) {
      loadABFile();
    }
  }, [props?.open, open]);

  const handleMinimize = () => {
    setIsMinimized(true);
  };

  const handleMaximize = () => {
    setIsMinimized(false);
  };

  const minimizedDialogStyle = {
    position: "absolute",
    bottom: "50px",
    right: "50px",
    width: "200px",
    height: "200px",
    borderRadius: "8px",
    boxShadow: theme.shadows[8],
    zIndex: 9999,
    padding: "10px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor:
      theme.palette.mode === "dark"
        ? theme.palette.grey[900]
        : theme.palette.background.paper,
    border: `1px solid ${theme.palette.divider}`,
    color: theme.palette.text.primary,
  };

  return (
    <>
      {isMinimized && showMinimize ? (
        <Box
          onClick={handleMaximize} // Click to maximize when minimized
          style={minimizedDialogStyle}
        >
          <Icon fontSize="large">
            <FuseSvgIcon size={30} color="primary">
              heroicons-outline:document-text
            </FuseSvgIcon>
          </Icon>
          <Typography
            variant="body2"
            color="textSecondary"
            sx={{ mt: 0.5 }}
          >
            {abNumber}
          </Typography>

          {/* Close Button */}
          <IconButton
            onClick={handleClose}
            color ="inherit"
            style={{
              position: "absolute",
              top: 5,
              right: 5,
              backgroundColor: theme.palette.action.hover,
              borderRadius: "50%",
              padding: 5,
            }}
          >
            <Icon fontSize="small">close</Icon>
          </IconButton>
        </Box>
      ) : (
        <Dialog open={open} onClose={handleClose} fullWidth maxWidth="xl"   fullScreen={isMobile}>
          <AppBar position="static">
            <Toolbar className="flex w-full justify-between">
              <Typography variant="subtitle1" color="inherit">
                {title}
              </Typography>

              <Box>
                {showMinimize && !isMinimized && (
                  <IconButton onClick={handleMinimize}>
                    <Icon>remove</Icon>
                  </IconButton>
                )}
                <IconButton onClick={handleClose} color="inherit">
                  <Icon>close</Icon>
                </IconButton>
              </Box>
            </Toolbar>
          </AppBar>
          <DialogContent classes={{ root: "p-8 sm:p-12" }}   sx={{ overflowY: "auto", WebkitOverflowScrolling: "touch" }}>
            {pdfUrl ? (
              <PDFViewer url={pdfUrl} hideToolbar={isMobile}/>
            ) : (
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                height="100%"
              >
                <Typography color="error" variant="body1">
                  {pdfError}
                </Typography>
              </Box>
            )}
          </DialogContent>
        </Dialog>
      )}
    </>
  );
}
